import { IconButton, SvgIcon } from '@mui/material';
import { FunctionComponent, useState } from 'react';

import PopOverMenu from '@Components/PopOverMenu';
import Icons from '@Constants/Icons.constants';

import TableActionsMenuProps from './TableActionsMenu.types';

const TableActionsMenu: FunctionComponent<TableActionsMenuProps> = (
  props: TableActionsMenuProps
): JSX.Element => {
  const { onClick, disabled, ...resProps } = props;

  /** States */
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const isOpen = Boolean(anchorEl);

  /** On Button Click Handler */
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    if (onClick) {
      onClick(event);
    }
  };

  /** Menu Close Handler */
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        sx={{
          p: '0',
          color: 'common.black',
          '&:hover': {
            backgroundColor: ({ colors }) => colors.iconPressed,
          },
        }}
        onClick={handleClick}
        disabled={disabled}
        aria-label="table actions menu"
      >
        <SvgIcon>{Icons.moreHoriz}</SvgIcon>
      </IconButton>
      <PopOverMenu
        open={isOpen}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        {...resProps}
      />
    </>
  );
};

export default TableActionsMenu;
